import React, { useState, ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Sidebar, NavTab } from "./Sidebar";
import { ToastContainer } from "./Toast";

interface LayoutProps {
  activeTab: NavTab;
  onSelectTab: (tab: NavTab) => void;
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ activeTab, onSelectTab, children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="app-layout">
      <Navbar onToggleSidebar={() => setIsSidebarOpen((prev) => !prev)} />
      <div className="layout-body">
        <Sidebar
          activeTab={activeTab}
          onSelectTab={onSelectTab}
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
        <main className="main-content">
          <div className="content-container">{children}</div>
        </main>
      </div>
      <ToastContainer />
    </div>
  );
};
